import { Dataset, DataFlowDSLAdapterRegistry, LinkedService, Metamodel, Owned } from 'shell-models-lib';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { BaseSqlFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/sql-base.adapter';
import { SqlDBSettings } from 'app/model/dataflow/dataset-settings/sql-db-settings';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { DatasetUtils } from 'app/model/dataset/dataset.utils';
import { DatasetFormatType, DataFlowDatasetSettings } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowAdapterUtils } from '../adapter.util';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlDBSettings)
})
export class SqlDBFormatAdapter extends BaseSqlFormatAdapter {
    /**
     * Supplements missing DSL properties for Fabric Migration.
     */
    public supplementPropsForFabricMigration(dataset: Dataset | undefined, linkedService: LinkedService | undefined, props: string[], isSource: boolean, isInline: boolean, _datasetSettings: DataFlowDatasetSettings | undefined, format?: string): void {
        if (linkedService) {
            const dbName = DatasetUtils.getDatabaseFromLinkedService(linkedService);
            if (dbName) {
                props.push(`database: ${DataFlowAdapterUtils.formatExpressionValue(dbName)}`);
            }
        }

        if (isInline || !dataset) {
            return;
        }

        props.push(`store: '${DatasetFormatType.SqlDB}'`);

        DataFlowAdapterUtils.supplementSqlSchemaAndTableFromDataset(dataset, props, isSource, format);
    }

    protected async toSourceDSL(sqlDbSettings: SqlDBSettings): Promise<string[]> {
        return super.toSourceDSL(sqlDbSettings);
    }

    protected async toSinkDSL(sqlDbSettings: SqlDBSettings): Promise<string[]> {
        return super.toSinkDSL(sqlDbSettings);
    }

    protected async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<SqlDBSettings> {
        const sqlDbSettings = Owned.create<SqlDBSettings>(SqlDBSettings.MODEL, owner);
        sqlDbSettings.initialize(undefined);
        await super.toSourceModel(owner, configs, handledConfigs, sqlDbSettings);
        return sqlDbSettings;
    }

    protected async toSinkModel(
        owner: DataFlowSink,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<SqlDBSettings> {
        const sqlDbSettings = Owned.create<SqlDBSettings>(SqlDBSettings.MODEL, owner);
        sqlDbSettings.initialize(undefined);
        await super.toSinkModel(owner, configs, handledConfigs, sqlDbSettings);
        return sqlDbSettings;
    }
}
